import { Component, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

import { CmsMedia } from '@shared/models/cms.model';
import { CmsImage } from '@shared/ui/cms-image/cms-image';

/** `row` = full-width accordion header (modules grid); `tag` = stacked module card (widget→platform). */
export type ModuleChipVariant = 'row' | 'tag';

@Component({
    selector: 'app-module-chip',
    imports: [NgTemplateOutlet, MatIconModule, CmsImage],
    templateUrl: './module-chip.html',
    styleUrl: './module-chip.scss',
})
export class ModuleChip {
    readonly label: InputSignal<string> = input.required<string>();
    readonly variant: InputSignal<ModuleChipVariant> = input<ModuleChipVariant>('row');
    readonly expandable: InputSignal<boolean> = input<boolean>(false);
    readonly expanded: InputSignal<boolean> = input<boolean>(false);
    readonly image: InputSignal<CmsMedia | null | undefined> = input<CmsMedia | null | undefined>();
    readonly toggled: OutputEmitterRef<void> = output<void>();
}
